import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var isProduction = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed';
export var RbdInvariant = /*#__PURE__*/function (_Error) {
  _inherits(RbdInvariant, _Error);
  var _super = _createSuper(RbdInvariant);
  function RbdInvariant(message) {
    var _this;
    _classCallCheck(this, RbdInvariant);
    _this = _super.call(this);
    _this.message = message;
    return _this;
  }
  _createClass(RbdInvariant, [{
    key: "toString",
    value: function toString() {
      return this.message;
    }
  }]);
  return RbdInvariant;
}( /*#__PURE__*/_wrapNativeSuper(Error));

// A copy-paste of tiny-invariant but with a custom error type
// Throw an error if the condition fails
export function rbdInvariant(condition, message) {
  if (condition) {
    return;
  }
  if (isProduction) {
    // In production we strip the message but still throw
    throw new RbdInvariant(prefix);
  } else {
    // When not in production we allow the message to pass through
    // *This block will be removed in production builds*
    throw new RbdInvariant("".concat(prefix, ": ").concat(message || ''));
  }
}